import { Button, Flex } from 'antd';

export const SESSION_RESTORE_FAILED_MESSAGE = '로그인 상태를 확인하지 못했습니다. 다시 시도해주세요.';

/** 일시적인 복원 실패를 같은 화면에서 알리고 수동 재시도만 제공한다. 자동 반복은 하지 않는다. */
export default function SessionRestoreError({ onRetry, pending = false, message = SESSION_RESTORE_FAILED_MESSAGE }) {
	return (
		<Flex vertical align="center" gap={12} style={{ padding: 24 }} role="alert">
			<span>{message}</span>
			<Button type="primary" onClick={onRetry} disabled={pending}>
				다시 시도
			</Button>
		</Flex>
	);
}
